<script lang="ts" setup>
const today = new Date();
</script>

<template>
  <footer class="page-footer mt-40 pb-20">
    <i18n-t keypath="home.footer.content" scope="global" tag="div" class="text-center text-14 color-hex-8B8B8B font-400 leading-22">
      <template #year>
        {{ today.getFullYear() }}
      </template>
    </i18n-t>
  </footer>
</template>

<style lang="scss" scoped>
</style>
